import React from 'react'
import { Hint } from '../../store/service/types';
import { Stack, Typography } from '@mui/material';

type Props = {
    hints: Hint[];
    unlockedHints: number;
}

const HintDrawer = ({hints, unlockedHints}: Props): JSX.Element => {
    if (unlockedHints === 0) {return (<></>)}

    return (
        <Stack direction={'column'}>
            <Typography variant={'h6'}>
                <i>Hints:</i>
            </Typography>
            {hints.map((hint, i) => (
                <Typography display={(i < unlockedHints) ? 'flex' : 'None'}>
                    {hint.description}
                </Typography>
            ))}
        </Stack>
    )
}

export default HintDrawer